/**
 * Cookie consent management mixin
 * Handles EU cookie law compliance
 */
export default {
    data() {
        return {
            show_cookie_consent: false,
            show_cookie_info_modal: false
        };
    },


    methods: {
        check_cookie_consent() {
            // Check if user has already accepted cookies
            const consent = localStorage.getItem('cookie_consent_accepted');
            if (!consent) {
                // Show consent popup after a short delay
                setTimeout(() => {
                    this.show_cookie_consent = true;
                }, 1000);
            }
        },

        accept_cookies() {
            // Store consent in localStorage
            localStorage.setItem('cookie_consent_accepted', 'true');
            localStorage.setItem('cookie_consent_date', new Date().toISOString());
            
            this.show_cookie_consent = false;
            this.show_cookie_info_modal = false;
            
            // Optional: Send analytics event that cookies were accepted
            this.track_cookie_consent('accepted');
        },

        accept_cookies_and_close() {
            this.accept_cookies();
        },

        show_cookie_info() {
            this.show_cookie_info_modal = true;
        },

        close_cookie_info() {
            this.show_cookie_info_modal = false;
        },

        track_cookie_consent(action) {
            // Simple tracking without external cookies
            console.log('Cookie consent:', action, new Date().toISOString());
            
            // Could send to server for compliance records
            // this.send_consent_record(action);
        },

        // Optional: Send consent record to server for compliance
        async send_consent_record(action) {
            try {
                const form_data = new FormData();
                form_data.append('request', 'record_cookie_consent');
                form_data.append('action', action);
                form_data.append('timestamp', new Date().toISOString());
                
                await axios.post('ajax.php', form_data, {
                    headers: {'Content-Type': 'multipart/form-data'}
                });
            } catch (error) {
                console.error('Error recording cookie consent:', error);
            }
        }
    }
};
